import React from 'react';
import PropTypes from 'prop-types';

export class NavTab extends React.Component {
  render() {
    const { show, isActive, url, text } = this.props;
    if (show) {
      if (isActive) {
        return <a className='nav-item is-tab is-active' href={url}>{text}</a>;
      } else {
        return <a className='nav-item is-tab' href={url}>{text}</a>;
      }
    } else {
      return null;
    }
  }
}

NavTab.propTypes = {
  show: PropTypes.bool,
  url: PropTypes.string,
  text: PropTypes.string,
  isActive: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/common/components/navbar/components/NavTab.jsx